import { ReactNode } from 'react';

type Props = {
  htmlFor?: string;
  children: ReactNode;
};

export default function FormLabel({ htmlFor, children }: Props) {
  return (
    <label htmlFor={htmlFor} className="font-semibold mb-1">
      {children}
    </label>
  );
}
